import * as Yup from "yup";
import { AbsenceCategory } from "../../../constants/absenceEnums";

export interface AdjustBalanceFormValues {
  absenceCategory: AbsenceCategory | null;
  amount: number;
  reason: string;
}

export const adjustBalanceValidationSchema = Yup.object({
  absenceCategory: Yup.number()
    .oneOf(
      [AbsenceCategory.Vacation, AbsenceCategory.SickDays],
      "Invalid absence category"
    )
    .required("Absence category is required"),
  amount: Yup.number()
    .required("Amount is required")
    .test(
      "non-zero",
      "Amount cannot be zero",
      (value) => value !== 0
    ),
  reason: Yup.string()
    .required("Reason is required")
    .max(500, "Reason cannot exceed 500 characters"),
});






